import CONFIGS from 'build/Config'
import Button from 'components/button'
import ButtonCloseMenu from 'components/button-close'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import LoadingScreen from 'components/loading-screen'
import { useSession } from 'contexts/session-context'
import { useState } from 'react'
import textServices from 'services/text-services'

const SolMezclasRanking = ({ ranking }: { ranking?: any }) => {
  const [{ user }] = useSession()

  const [prevRank, setPrevRank] = useState(false)

  const handleClick = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'RANKING :: Descubrir',
      section: 'RANKING'
    })
    setPrevRank(!prevRank)
  }

  if (!ranking) <LoadingScreen />

  if (!ranking?.currentPosition && !CONFIGS.rankingDisabled) {
    return (
      <div className='ranking-profile'>
        <ButtonCloseMenu paramFn={handleClick} />
        <span></span>

        <div className='px-5 contain-text'>
          <h2 className='no-ranking__title'>
            EL RANKING SE MOSTRARÁ DESPUÉS DE TU PRIMERA COMPRA
          </h2>
          <p className='no-ranking__subtitle' style={{ color: '#15141A' }}>
            Tu posición se actualizará en un plazo de 24 horas después de tu primera compra. Vuelve a intentarlo más tarde.
            <br /><br />
            <b>
              Tu cuenta ya está vinculada con el siguiente número de teléfono: {user?.phoneNumber}
              <br /><br />
              Recuerda que debe ser el mismo número que utilizaste en tu cuenta de SumaSix.
            </b>
          </p>
        </div>

        <div className='px-5 mt-6'>
          <Button onClick={handleClick}>
            Volver
          </Button>
        </div>
      </div>
    )
  }

  const rest = (ranking?.previousPosition?.points - ranking?.currentPosition?.points)

  return (
    <div className='ranking-profile'>
      <img src={`${AZURE_BASE_URL}/ranking-img.webp`} alt="Imagen de item a ganar" className='w-full' />

      <div className='flex flex-1 flex-col gap-5 mt-6'>
        <h2 className='ranking-profile__title'>
          {textServices.findByText('profile/ranking/title', {
            es: 'Tus tickets',
            en: 'Your tickets'
          })}
        </h2>

        <div className='flex items-center justify-center gap-5 ranking-profile__container__accumulated'>
          <div>
            <p className='ranking-profile__subtitle'>
              {textServices.findByText('profile/ranking/box/one', {
                es: 'tickets acumulados:',
                en: 'accumulated tickets:'
              })}
            </p>
            <div className='ranking-profile__box'>
              {ranking?.currentPosition?.points ?? '-'}
            </div>
          </div>

          <div className='ranking-profile__container__position'>
            <p className='ranking-profile__subtitle'>
              {textServices.findByText('profile/ranking/box/two', {
                es: 'tu posición:',
                en: 'your position:'
              })}
            </p>
            <div className={`ranking-profile__box ${ranking?.currentPosition?.id === 1 ? 'ranking-profile__box__first-place' : ''}`}>
              {ranking?.currentPosition?.id ?? '-'}
            </div>
          </div>
        </div>

        {
          CONFIGS.rankingDisabled ? (
            <div>
              <p className='ranking-profile__text'>
                Esta dinámica ha finalizado. Puedes revisar en qué posición has quedado en el ranking.<br /><br />¡Nos vemos en la próxima!
              </p>
            </div>
          ) : (
            <div>
              <p className='ranking-profile__text'>
                {textServices.findByText('profile/ranking/text', { es: '¡Recuerda! A máyor cantidad de tickets SORIANA QUE subas, MÁS OPORTUNIDAD DE GANAR UN FRIGOBAR TENDRÁS.', en: '' })}
              </p>
              <p className='ranking-profile__subtext'>
                Aclaración: Ten en cuenta que el ranking se actualiza 1 vez al día por lo que no verás tu posición real reflejada al instante.
              </p>
            </div>
          )
        }
      </div>

      {
        !CONFIGS.rankingDisabled && (
          <div className='px-5 mt-6 flex flex-col items-center gap-2'>
            <div className='rank-box'>
              {
                !prevRank
                  ? (
                    <div className='rank-box__discover'>
                      <p>
                        Descubre {textServices.findByText('profile/ranking/positionOne', 'CUANTAS LATAS')} te <br />
                        falta para subir de puesto
                      </p>
                    </div>
                  )
                  : (
                    ranking?.currentPosition?.id === 1
                      ? (
                        <div className='rank-box__first-place'>
                          <p>
                            ¡estás en el
                            {" "}
                            <span className='rank-box__first-place__rest'>
                              1er puesto
                            </span>!
                            <br />
                            <span className='rank-box__first-place__bottom'>
                              SIGUE ASÍ PARA NO BAJAR DE PUESTO
                            </span>
                          </p>
                        </div>
                      )
                      : (
                        <div className='rank-box__text'>
                          <p>
                            TE FALTAN
                            <span className='rank-box__text__rest'>
                              {" "}{rest === 0 ? 1 : (rest ?? 1)}{" "}
                            </span>
                            {textServices.findByText('profile/ranking/positionTwo', 'LATAS')}
                            <br />
                            <span className='rank-box__text__bottom'>
                              PARA PASAR AL SIGUIENTE PUESTO
                            </span>
                          </p>
                        </div>
                      )
                  )
              }
            </div>

            <Button onClick={handleClick}>
              {prevRank ? 'OCULTAR' : 'DESCUBRIR'}
            </Button>
          </div>
        )
      }
    </div>
  )
}

export default SolMezclasRanking
